import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { AsyncPipe, CommonModule } from '@angular/common';
import { DxDataGridComponent, DxDataGridModule, DxPopupModule, DxTextBoxModule } from 'devextreme-angular';
import { ActivatedRoute, Router } from '@angular/router';
import { LoggingService } from 'src/app/services/logging.service';
import { AppGlobals } from '../../app.globals';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-logging-popup',
    imports: [CommonModule, DxPopupModule, DxDataGridModule, DxTextBoxModule, AsyncPipe],
    templateUrl: './logging-popup.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./logging-popup.component.css']
})
export class LoggingPopupComponent implements OnInit, OnDestroy {
  @ViewChild('loggingGrid') loggingGrid;

  @Output() onHiding = new EventEmitter();

  dxGridVisible: boolean = true;

  dataSource = new Array();

  contentLoadedVisible: boolean = true;
  searchTerm: string = '';

  @ViewChild(DxDataGridComponent, { static: false })
  dataGrid: DxDataGridComponent;

  gridVisible: boolean = false;

  logRequest: any = {
    LogRequest: {
      LogItemID: null,
      LogType: null,
      SearchTerm: '',
    },
  };

  logFeedbackResponse: any = '';

  @Input() showLogPopUp: boolean = true;

  isPopupVisible: boolean = false;

  availableHeight: any = 'auto';

  noData: string = $localize`:@@noLogsToShow:No Logs To Show`;

  searchTermLogs: any = AppGlobals.searchPanelLogsText;

  @Output() disablePopUpWindow = new EventEmitter<any>();
  onSearching: boolean = false;

  queryParamsSubscription: Subscription;
  queryParams: any;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private loggingService: LoggingService,
    public appGlobals: AppGlobals
  ) {
    this.queryParamsSubscription = this.route.queryParams.subscribe(params => {
      this.queryParams = params;
    });
  }

  ngOnInit(): void {}

  ngOnDestroy(): void {
    this.queryParamsSubscription.unsubscribe();
  }

  handleOnHiding() {
    this.appGlobals.$showLogs.next(false);
    this.appGlobals.setSearchPanelLogsText('');
    this.searchTermLogs = '';
    this.onHiding.emit();
  }

  getLogsForGrid(logId: any, taskId: any, logType: any, searchterm: any): void {
    this.appGlobals.ShowGlobalLoader();
    if (this.searchTermLogs === '') {
      this.searchTermLogs = null;
    }

    let url = this.router.url;
    let splitUrl = url.split('/');
    let projectId = Number(splitUrl[2]);

    this.logRequest = {
      LogRequest: {
        LogItemID: logId,
        TaskId: taskId,
        LogType: logType,
        SearchTerm: searchterm,
      },
    };

    this.loggingService.getLogs(this.logRequest).then(
      result => {
        if (result.hasError === true) {
          AppGlobals.ShowErrorMessage(result.feedback);
          this.appGlobals.HideGlobalLoader();
        } else {
          this.logRequest = result;
          this.appGlobals.HideGlobalLoader();
        }
      },
      error => {
        AppGlobals.ShowErrorMessage(error);
        this.appGlobals.HideGlobalLoader();
      }
    );
  }

  setLogGridHeight() {
    return 'auto';
  }

  doSearch(e: any, text: any): void {
    if ((text = 'on-showing')) {
      setTimeout(() => {
        this.onSearching = false;
      }, 0);
    } else {
      this.onSearching = false;
    }
    if (this.onSearching == false) {
      this.onSearching = true;
    }
    this.appGlobals.setSearchPanelLogsText(e.value);
    let url = this.router.url;
    let splitUrl = url.split('?')[0].split('/');
    let projectId = splitUrl[2];
    let siteId = splitUrl[4];

    if (e.value === '') {
      e.value = null;
    }

    let type = splitUrl[1];
    let taskId = null;

    //// SITES LIST LOGS ////
    if (splitUrl[1] === 'grid-connections') {
      type = 'site-overview';
      projectId = null;
    }

    //// PROJECTS LIST LOGS ////
    if (splitUrl[1] === 'projects') {
      type = 'project';
      projectId = null;
      taskId = null;
    }

    //// SITE LOGS (TABS) ////
    if (splitUrl[1] === 'site') {
      if (splitUrl[3] === 'grid-connection') {
        type = 'grid-connection';
      }
      if (splitUrl[3] === 'properties') {
        type = 'site';
      }
      if (splitUrl[3] === 'infrastructure') {
        type = 'site';
      }

      //// PROJECT LOGS ////
      if (splitUrl[5] === 'projectInfo') {
        type = 'project-info';

        if (splitUrl[6] === 'schedule') {
          projectId = splitUrl[4];
          type = 'project-schedule';
        }
      }

      if (splitUrl[5] === 'tasks') {
        type = 'tasks';
        projectId = splitUrl[4];
        taskId = null;
      }

      if (splitUrl[5] === 'documents') {
        type = 'documents';
        projectId = null;
      }

      if (splitUrl[3] === 'project') {
        if (splitUrl[5] === 'comments') {
          type = 'comments';
          projectId = splitUrl[4];
        }
        if (splitUrl[5] === 'microtasks') {
          type = 'micro-tasks';
          projectId = splitUrl[4];
        }
      }

      if (splitUrl[5] === 'calendar') {
        type = 'calendar';
        projectId = splitUrl[4];
      }

      if (splitUrl[5] === 'gallery') {
        type = 'project-gallery';
        projectId = splitUrl[4];
      }

      if (splitUrl[5] === 'project-contacts') {
        type = 'project-contacts';
        projectId = null;
      }

      if (splitUrl[5] === 'project-costs') {
        type = 'project-cost';
        projectId = splitUrl[4];
      }

      if (splitUrl[5] === 'project-hub') {
        type = 'projecthub';
        projectId = splitUrl[4];
      }
    }

    //// MY TASKS LOGS ////
    if (splitUrl[1] === 'user-tasklist') {
      type = 'my-tasks';
      projectId = null;
    }

    //// PROJECT COST OVERVIEW LOGS ////
    if (splitUrl[1] === 'projectcost-overview') {
      type = 'project-cost-overview';
      projectId = null;
    }

    //// CONTACT LOGS ////
    if (splitUrl[1] === 'contacts') {
      if (splitUrl[2] === 'companies') {
        type = 'contact-company';
        projectId = null;
      }
      if (splitUrl[2] === 'persons') {
        type = 'contact-person';
        projectId = null;
      }
      if (splitUrl[2] === 'company') {
        type = 'contact-company';
        if (splitUrl[3]) {
          projectId = splitUrl[3];
        }
      }
      if (splitUrl[2] === 'person') {
        type = 'contact-person';
        if (splitUrl[3]) {
          projectId = splitUrl[3];
        }
      }
      if (splitUrl[2] === 'addCompany' || splitUrl[2] === 'addPerson') {
        type = 'document';
        projectId = null;
      }
    }
    //// CONTACT LOGS ////
    if (splitUrl[1] === 'contacts') {
      if (splitUrl[2] === 'companies') {
        type = 'contact-company';
        projectId = null;
      }
      if (splitUrl[2] === 'persons') {
        type = 'contact-person';
        projectId = null;
      }
      if (splitUrl[2] === 'company') {
        type = 'contact-company';
        if (splitUrl[3]) {
          projectId = splitUrl[3];
        }
      }
      if (splitUrl[2] === 'person') {
        type = 'contact-person';
        if (splitUrl[3]) {
          projectId = splitUrl[3];
        }
      }
      if (splitUrl[2] === 'addCompany' || splitUrl[2] === 'addPerson') {
        type = 'document';
        projectId = null;
      }
    }

    //// TECH COMPONENTS LOGS ////
    if (splitUrl[1] === 'tech-components') {
      type = 'tech-components';
      projectId = this.appGlobals.$logItemId.getValue()?.toString() ?? null;
    }

    ////    WIKI LOGS    //////
    if (splitUrl[1] === 'wiki') {
      type = 'wiki';
      projectId = splitUrl[3];
    }

    //// CONFIG LOGS ////
    if (splitUrl[1] === 'config') {
      if (splitUrl[2] === 'taskconfig') {
        type = 'task-config';
        projectId = null;
      }
      if (splitUrl[2] === 'folder-config') {
        type = 'site-folders';
        projectId = null;
      }
      if (splitUrl[2] === 'contact-tags' || (splitUrl[2] === 'tags' && splitUrl[3] === 'contacts')) {
        type = 'tags';
        projectId = null;
      }
      if (splitUrl[2] === 'spark-tags' || (splitUrl[2] === 'tags' && splitUrl[3] === 'spark')) {
        type = 'spark-tags';
        projectId = null;
      }

      if (splitUrl[2] === 'export-config') {
        type = 'export-config';
        projectId = null;
      }
      if (splitUrl[2] === 'email-report-config') {
        type = 'email-report-config';
        projectId = null;
      }
      if (splitUrl[2] === 'traffic-light-config') {
        type = 'traffic-light-config';
        projectId = null;
      }
      if (splitUrl[2] === 'templates-costs-templates') {
        type = 'project-cost-templates';
        projectId = null;
      }
      if (splitUrl[2] === 'cost-category-config') {
        type = 'project-cost-categories';
        projectId = null;
      }
      if (splitUrl[2] === 'database-export') {
        type = 'database-export';
        projectId = null;
      }
      if (splitUrl[2] === 'technical-components-config') {
        type = 'technical-components-config';
        projectId = null;
      }
      if (splitUrl[2] === 'project-config') {
        if (splitUrl[3] === 'configuration') {
          type = 'project-configuration';
          projectId = null;

          if (splitUrl[4] === 'tasks') {
            type = 'task-config';
            projectId = null;
          }
        } else if (splitUrl[3] === 'project-parameters') {
          type = 'proj-params';
          projectId = null;
        } else if (splitUrl[3] === 'project-schedule') {
          type = 'schedule-config';
          var areaTypeId = this.queryParams.areaTypeId;
          projectId = areaTypeId;
        } else if (splitUrl[3] === 'reasons') {
          type = 'reasons';
          projectId = null;
        }
      }
      if (splitUrl[2] == 'general-config') {
        if (splitUrl[3] == 'organization') {
          type = 'departments';
          projectId = null;
        }
      }
      if (splitUrl[2] === 'user-permissions') {
        type = 'permissions';
        projectId = null;
      }
      if (splitUrl[2] === 'property-config') {
        //TODO: Add property config Logs
        return;
      }
      if (splitUrl[2] === 'template-config') {
        type = 'templates';
        projectId = null;
      }
    }

    if (splitUrl[1] === 'tables') {
      type = 'dynamic-table';
      projectId = splitUrl[2];
    }

    if (splitUrl[1] === 'contracts') {
      console.log('splitUrl', splitUrl);
      if (!splitUrl.includes('edit')) {
        type = 'contract';
        projectId = null;
      } else {
        type = 'contract';
        projectId = splitUrl[3];
      }
    } else if (splitUrl[3] === 'site-contracts') {
      type = 'site-contracts';
      projectId = splitUrl[2];
    }

    if (splitUrl[2] === 'contracts-config') {
      type = 'contract-config';
      projectId = null;
    }

    // Set logitemid based on the current tab
    let logitemid = null;
    if (type === 'project-info') {
      logitemid = siteId;
    } else {
      logitemid = projectId; // Use the current logic for other tabs
    }

    this.getLogsForGrid(logitemid, taskId, type, e.value);
  }

  setPopUpVisibilityFromChild(e: any): void {
    if (e === false) {
      this.disablePopUpWindow.emit(false);
    }
  }
}
